// extracted by mini-css-extract-plugin
export default {"wrapper":"intentionItem_wrapper__kKRqQ"};